import React from 'react'
import { CouponDetailPageProps } from 'src/pages/CouponDetailPage'
import { Divider } from 'src/components/common/Divider'
import styled from 'styled-components'
import {
  Noto_body1_b16,
  Noto_body2_m14,
  Noto_body3_b12,
  Noto_body3_r12,
} from 'src/styles/fonts/NotoSansKrFonts'
import { ellip } from 'src/styles/mixin'
import { Roboto_num1_b24, Roboto_num3_r14 } from 'src/styles/fonts/RobotoFonts'
import { Chips } from 'src/components/common/Chips'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import HotDealPreceed from 'src/pages/MainPage/_components/FloatItemHotDealCoupon/HotDealPreceed'
import { HotDealCouponDetailSpace } from 'src/types/api'
import RenderIf from 'src/components/common/RenderIf'
import coupon_thumbnail_default from 'src/assets/images/coupon_thumbnail/coupon_thumbnail_default.png'
import { getBrandAndCouponName } from 'src/utils'

const CouponDetailPrimaryInfo = ({
  couponDetailData,
}: Pick<CouponDetailPageProps, 'couponDetailData'>) => {
  const { CouponName, SalePrice, DiscountRate, RegularPrice, CouponType, CouponImage, ValidDay } =
    couponDetailData!
  const { EndDT } = couponDetailData! as HotDealCouponDetailSpace.Response
  const hotDealCoupon = CouponType === 1

  const CouponDetailCouponImage = ({ src }: { src?: string }) => {
    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
      e.currentTarget.src = coupon_thumbnail_default
    }
    return <S.CouponImg src={src} onError={handleImageError} alt="쿠폰 이미지" />
  }

  return (
    <Container $option="flex_column">
      <S.CouponDetailImageWrap $option="flex_column">
        <CouponDetailCouponImage src={CouponImage} />
        <RenderIf when={hotDealCoupon}>
          <HotDealPreceed EndDT={EndDT} position={{ l: '20px', t: '-45px' }} />
        </RenderIf>
      </S.CouponDetailImageWrap>
      <S.CouponDetailPrimaryCouponInfo $option="flex_column">
        <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
          {getBrandAndCouponName(CouponName).brandName}
        </Typography>
        <S.CouponDetailCouponName $fontStyle={Noto_body1_b16}>
          {getBrandAndCouponName(CouponName).couponName}
        </S.CouponDetailCouponName>
        <S.CouponDetailPriceContainer $option="flex_row" $column_gap="5px">
          <Typography $fontStyle={Roboto_num1_b24} $color="var(--brand-50)">
            {Math.floor((DiscountRate as number) * 10) / 10}%
          </Typography>
          <S.CouponDetailSalePrice $fontStyle={Roboto_num1_b24} $color="var(--black-90)">
            {SalePrice?.toLocaleString()}원
          </S.CouponDetailSalePrice>
          <S.CouponDetailRegularPrice $fontStyle={Roboto_num3_r14} $color="var(--black-50)">
            {RegularPrice?.toLocaleString()}원
          </S.CouponDetailRegularPrice>
        </S.CouponDetailPriceContainer>
        <Chips.Item size="small">유효기간 {ValidDay}일</Chips.Item>
        <RenderIf when={hotDealCoupon}>
          <S.CouponDetailHotDealCouponNotice $option="flex_column" $row_gap="6px">
            <Typography $fontStyle={Noto_body3_r12} $color="var(--black-50)">
              - 구매한 핫딜 상품을{' '}
              <Typography $fontStyle={Noto_body3_b12} $color="var(--red-30)">
                재판매
              </Typography>
              할 경우,{' '}
              <Typography $fontStyle={Noto_body3_b12} $color="var(--red-30)">
                회원 자격이 제한
              </Typography>
              될 수 있습니다.
            </Typography>
            <Typography $fontStyle={Noto_body3_r12} $color="var(--black-50)">
              - 핫딜 상품은 상품별로{' '}
              <Typography $fontStyle={Noto_body3_b12} $color="var(--red-30)">
                1인 1개{' '}
              </Typography>
              가능하며, 월 10회까지 핫딜 구매 혜택을 받으실 수 있습니다.
            </Typography>
            <Typography $fontStyle={Noto_body3_r12} $color="var(--black-50)">
              - 상품 소진 시 본 이벤트는 예정 기간에 상관 없이 조기 종료될 수 있습니다.
            </Typography>
          </S.CouponDetailHotDealCouponNotice>
        </RenderIf>
      </S.CouponDetailPrimaryCouponInfo>
      <Divider />
    </Container>
  )
}
export default CouponDetailPrimaryInfo

const S = {
  CouponDetailImageWrap: styled(Container)`
    background-color: var(--black-4);
    justify-content: center;
    align-items: center;
  `,
  CouponDetailPrimaryCouponInfo: styled(Container)`
    padding: 30px 20px;
  `,
  CouponDetailCouponName: styled(Typography)`
    margin: 6px 0 20px 0;
    ${ellip('line2')};
  `,
  CouponDetailPriceContainer: styled(Container)`
    align-items: center;
    margin-bottom: 20px;
  `,
  CouponDetailRegularPrice: styled(Typography)`
    text-decoration: line-through;
  `,
  CouponDetailHotDealCouponNotice: styled(Container)`
    margin-top: 20px;
    border-radius: 12px;
    border: 1px solid var(--black-6);
    padding: 14px;
  `,
  CouponDetailSalePrice: styled(Typography)`
    display: flex;
    align-items: center;
  `,
  CouponImg: styled.img`
    width: 100%;
    background: white;
  `,
}
